import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FascicoloFull } from '../../../models/fascicolo/fascicolo-full';
import { Reato } from '../../../models/reato';
import { SezioneReati } from '../../../models/sezioni/sezione-reati';
import { ReatiEditComponent } from './reati-edit.component';

declare var closeModal: any;
declare var openModal: any;

@Component({
    selector: 'div [reato-mod-edit]',
  templateUrl: 'reato-mod-edit.html',
  host: { '[class.modal]': '\'true\'', '[class.fade]': '\'true\'', '[attr.role]': '\'dialog\'' }
})

export class ReatoModEdit {
  @Output() onReturn: EventEmitter<SezioneReati> = new EventEmitter<SezioneReati>();
  @ViewChild('formReatoEdit') formReato: ReatiEditComponent;

  inizializza(sezione: SezioneReati, reato: Reato, fascicolo: FascicoloFull, urlUpdate: string, urlReadSezioneAltreParti: string, urlReadSezioneControparti: string) {
    this.formReato.inizializza(sezione, reato, fascicolo, urlUpdate, urlReadSezioneAltreParti, urlReadSezioneControparti);
    openModal('modalmodReato');
  }

  createForm() {
    this.formReato.createForm();
  }

  manageModal(sezioneReati: SezioneReati) {
      closeModal('modalmodReato');
      this.onReturn.emit(sezioneReati);
  }
}
